var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.showCaptchaError
    ? _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showForm,
              expression: "showForm"
            }
          ],
          staticClass: "sms-confirm _wide",
          class: { _checkout: _vm.isCheckout },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.sendReceivedCodeMethod($event)
            }
          }
        },
        [
          !_vm.isCheckout && _vm.$slots.header
            ? _c(
                "div",
                { staticClass: "sms-confirm__header" },
                [_vm._t("header", null, { close: _vm.close })],
                2
              )
            : _vm.isCheckout
            ? _c("div", { staticClass: "sms-confirm__header" }, [
                _c("p", { staticClass: "sms-confirm__header-title" }, [
                  _vm._v(
                    "\n      Введите код подтверждения, отправленный на указанный вами номер\n    "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form-item",
            {
              staticClass: "sms-confirm__form-item sms-confirm__form-input",
              attrs: {
                label: _vm.isCheckout ? "" : "Код подтверждения",
                "text-after":
                  _vm.isCheckout || _vm.hideResendBtn
                    ? ""
                    : "На указанный вами номер отправлен код",
                "is-bold-label": "",
                "text-error": _vm.errorSendReceivedCode
              }
            },
            [
              _c("input-control", {
                attrs: { inputmode: "numeric" },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-item",
            { staticClass: "sms-confirm__form-item sms-confirm__form-button" },
            [
              _c(
                "button-control",
                {
                  attrs: {
                    loading: _vm.isSendingCode || _vm.isFetchingCode,
                    disabled: _vm.isDisabledInput,
                    "is-block": "",
                    "native-type": "submit",
                    "is-added-disabled-class-name": _vm.isDisabledInput,
                    type: _vm.isCheckout ? "secondary" : "default"
                  }
                },
                [_vm._v("\n      Отправить\n    ")]
              ),
              _vm._v(" "),
              _vm.isShowBackBtn
                ? _c(
                    "button-control",
                    {
                      staticClass: "personal-data__user-button",
                      attrs: {
                        "native-type": "button",
                        type: "secondary",
                        "is-block": "",
                        loading: _vm.isSendingCode || _vm.isFetchingCode,
                        disabled: _vm.isSendingCode
                      },
                      on: { click: _vm.close }
                    },
                    [_vm._v("\n      Назад\n    ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hideResendBtn
            ? _c(
                "form-item",
                { staticClass: "sms-confirm__form-item" },
                [
                  _vm.isCounting
                    ? _c("vue-countdown", {
                        ref: "countdown",
                        staticClass: "sms-confirm__countdown",
                        attrs: { time: _vm.timeLeft },
                        on: { end: _vm.handlerEndCountdown },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(props) {
                                return [
                                  _vm._v(
                                    "\n        Получить код повторно можно через:\n        " +
                                      _vm._s(props.minutes) +
                                      "\n        " +
                                      _vm._s(
                                        _vm._f("plural")(props.minutes, [
                                          "минуту",
                                          "минуты",
                                          "минут"
                                        ])
                                      ) +
                                      ",\n        " +
                                      _vm._s(props.seconds) +
                                      "\n        " +
                                      _vm._s(
                                        _vm._f("plural")(props.seconds, [
                                          "секунду",
                                          "секунды",
                                          "секунд"
                                        ])
                                      ) +
                                      ",\n      "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3039765345
                        )
                      })
                    : _vm.timeLeft < 0
                    ? _c(
                        "button-control",
                        {
                          staticClass: "sms-confirm__resend-code",
                          attrs: { type: "link-dashed" },
                          on: { click: _vm.sendCode }
                        },
                        [_vm._v("\n      Получить код повторно\n    ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.footer
            ? _c(
                "div",
                { staticClass: "sms-confirm__form-item" },
                [_vm._t("footer")],
                2
              )
            : _vm._e()
        ],
        1
      )
    : _c(
        "notification",
        { staticClass: "sms-confirm__notification", attrs: { type: "error" } },
        [_vm._v("\n  " + _vm._s(_vm.captchaErrorText) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }